import { parseImageId as e, parseJSON as t } from "./parseImageId.es.js";
// lib/TTVisual/lib/consume.ts
var n = async ({ input: e }) => {
	if (Array.isArray(e)) throw Error("VisualEx plugin expected string for consumation, not a list/array");
	if (typeof e.data != "string") throw Error("VisualEx plugin expected string for consumation");
	return r(e);
}, r = async (t) => {
	let n = await o(t);
	return {
		...t,
		data: {
			id: crypto.randomUUID(),
			class: "block",
			type: "tt/visual",
			properties: {
				href: n.href,
				proxy: n.proxy,
				uri: `http://tt.se${e(n.href)}`,
				rel: n.rel || "self",
				text: n.text,
				byline: n.byline,
				width: n.width,
				height: n.height,
				type: "tt/picture"
			},
			children: [
				{
					type: "tt/visual/image",
					class: "void",
					children: [{ text: n.href }]
				},
				{
					type: "tt/visual/text",
					class: "text",
					children: [{ text: n.text }]
				},
				{
					type: "tt/visual/byline",
					class: "text",
					children: [{ text: n.byline }]
				}
			]
		}
	};
}, i = 15e3, a = async (e) => await new Promise((t, n) => {
	let r = new Image(), a = setTimeout(() => {
		n(/* @__PURE__ */ Error(`Timed out loading image after ${i}ms`));
	}, i);
	r.onload = () => {
		clearTimeout(a), t({
			width: r.width,
			height: r.height
		});
	}, r.onerror = () => {
		clearTimeout(a), n(/* @__PURE__ */ Error("Failed to load image"));
	}, r.src = e;
}), o = async (n) => {
	if (typeof n.data != "string") throw Error("VisualEx plugin expected string for consumation");
	let r = t(n.data);
	if (r) return r;
	let i = e(n.data), o = await a(`https://tt.se/media/image/${i}_WatermarkPreview.jpg`);
	if (!o) throw Error("Failed to get image resolution");
	let { width: s, height: c } = o;
	return {
		type: "tt/picture",
		href: `http://tt.se/media/image/${i}_WatermarkPreview.jpg`,
		uri: `http://tt.se/media/image/${i}`,
		byline: "",
		text: "",
		width: s,
		height: c
	};
};
export { n as consume };
